import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ClientFeatureOptions } from '@uc/web/shared/data-models';
import { RedirectToUtils } from '../../utils/redirect-to.utils';
import { RouterLink } from '@angular/router';
import { WriteReviewBtnComponent } from '@uc/web/shared/buttons';
import { Product } from '@uc/shared/data-models';

@Component({
	selector: 'uc-university-header-title',
	templateUrl: './university-header-title.component.html',
	imports: [RouterLink, WriteReviewBtnComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversityHeaderTitleComponent {
	uniId = input.required<number>();
	product = input.required<Product>();
	name = input.required<string>();
	slug = input.required<string>();
	paidFeatures = input.required<ClientFeatureOptions[]>();
	subdirectory = input.required<string>();
	recommendedPercentage = input<number>();
	redirectTo = new RedirectToUtils();
}
